import {createTheme, Direction, ThemeProvider as MuiThemeProvider} from "@mui/material/styles";

export const themeObj = {
    direction: "rtl" as Direction,
    typography: {
        fontFamily: [
            "IRANSansFaNum",
            "-apple-system",
            "BlinkMacSystemFont",
            '"Segoe UI"',
            "Roboto",
            '"Helvetica Neue"',
            "Arial",
            "sans-serif",
            '"Apple Color Emoji"',
            '"Segoe UI Emoji"',
            '"Segoe UI Symbol"',
        ].join(","),
    },
    palette: {
        primary: {
            main: "#1062D0",
            seconary: "#1062D0",
            light: "#E8F1FF",
        },
        success: {
            main: "#24AF22",
            light: "#E7F5E9",
        },
        error: {
            main: "#CB0B0B",
        },
        warning: {
            main: "#D68000",
        },
        text: {
            primary: "#3D3D3D",
            secondary: "#6F6F6F",
            disabled: "#AEAEAE",
        },
        disabled: {
            main: "#6F6F6F",
            light: "#f6f6fa",
            contrastText: "#AEAEAE",
        },
    },
    shape: {
        borderRadius: 8,
    },
};

const theme = createTheme(themeObj);

declare module "@mui/material/styles" {
    interface Palette {
        disabled: Palette["primary"];
    }

    // allow configuration using `createTheme`
    interface PaletteOptions {
        disabled?: PaletteOptions["primary"];
    }
}

// Update the Button's color prop options
declare module "@mui/material/Button" {
    interface ButtonPropsColorOverrides {
        disabled: true;
    }
}

// Update the Button's color prop options
declare module "@mui/material/SvgIcon" {
    interface SvgIconPropsColorOverrides {
        disabled: true;
    }
}

const AppThemeProvider = ({children}: ChildrenPropType) => {
    return <MuiThemeProvider theme={theme}>{children}</MuiThemeProvider>;
};

export default AppThemeProvider;
